import { useCallback, useEffect } from "react";
import { GlobalHeaderState, NEWRELIC_TABLES, recordNREvent, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";
import { isAndroidPlatform } from "@swiggy-private/core-ui";

// Used to take device back press control from native in cases
// where popState event is not triggered
// Read - https://swiggy.slack.com/archives/C097353BUC9/p1759865441683069?thread_ts=1759819890.288929&cid=C097353BUC9
const useNativeCustomBackHandling = (onBack: () => void) => {
    const platform = (GlobalHeaderState.getHeader(SwgyHeaderKeysList.platform) || "").toLowerCase();
    const isAndroid = isAndroidPlatform(platform);

    const removeCustomBack = useCallback(() => {
        if (isAndroid) {
            const revert = new URL(window.location.href);
            revert.searchParams.delete("custom_back");
            history.replaceState({ ...history.state }, "", revert.toString());
        }
    }, [isAndroid]);

    useEffect(() => {
        if (isAndroid) {
            const url = new URL(window.location.href);
            url.searchParams.set("custom_back", "true");
            history.replaceState({ ...history.state }, "", url.toString());
        }
    }, [isAndroid]);

    useEffect(() => {
        return () => {
            if (isAndroid) {
                removeCustomBack();
            }
        };
    }, [isAndroid, removeCustomBack]);

    useEffect(() => {
        if (typeof window !== "undefined" && isAndroid) {
            window.handleHardwareBack = (): void => {
                recordNREvent({
                    eventType: NEWRELIC_TABLES.NATIVE_CUSTOM_BACK_HANDLING,
                });
                onBack();
            };
        }
        return () => {
            if (typeof window !== "undefined" && isAndroid) {
                window.handleHardwareBack = () => void 0;
            }
        };
    }, [onBack, isAndroid]);

    return removeCustomBack;
};

export default useNativeCustomBackHandling;
